import React, { useState, useEffect, useRef } from "react";
import { styled, useTheme } from "@mui/material/styles";
import axios from "axios";
import { useSelector } from "react-redux";
import Select from "react-select";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from 'react-router-dom';
import { Tooltip, Typography } from "@mui/material";
import CommonAlert from "../../../Commonalert/commonalert";
import KeywordEditForm from "./KeywordEditForm";
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { Container, Grid, Box } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import GainedKeywordssvg from "../Asset/esocardicon/RankingComparison/GainedKeywords.svg";
import Chart from "react-apexcharts";
import WarningCount from ".././Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from ".././Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Commoncard from "../Commoncard";

const PreferredList = (props) => {


  const [cardData, setCardData] = useState([]);
  const [keywordData, setKeywordData] = useState("Country");
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalIsFilter, setmodalIsFilter] = React.useState(false);
  const [columns, setColumns] = useState([]);
  const [deleteId, SetDeleteId] = useState("")
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [keywordeditpopup, setKeywordEditPopup] = useState(false);
  const [selectedKeyword, setSelectedKeyword] = useState('');
  const [submitKeyword, setSubmitKeyword] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [succespopup, setsuccespopup] = useState();
  const [keywordaddpopup, setkeyWordAddPopup] = useState(false);
  const [campError, setCampError] = useState('');
  const [campaignCount, setCampaignCount] = useState(0);
  const [totalKeywordCount, setTotalKeywordCount] = useState(0);
  const [barChartData, setBarChartData] = useState([]);
  const noCampPageId = props.campTabSelection ? false : true;
  const [isCampaignCleared, setIsCampaignCleared] = useState(noCampPageId);

  const navigate = useNavigate();


  const handleDeleteClick = (id) => {
    SetDeleteId(id);
    setIsOpen(true);
  };

  const handleConfirmDelete = () => {
    DeleteBrandedterm(deleteId);
  };

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const GetDefaultSettings = async () => {
    setLoading(true);
    setKeywordData([]);
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}settings/keywordsettings_view/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      setLoading(false);
      var firArray = [
        {
          field: "campaign_name",
          headerName: "Campaign Name",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          sortable: true,
          disableClickEventBubbling: true,
          description: 'Campaign names that have been added to the domain.',
        },

        {
          field: "keyword_name",
          headerName: "Keyword Name",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          sortable: true,
          disableClickEventBubbling: true,
          description: 'The list of keywords is provided in campaign settings.',
        },
        {
          field: "prefered_url",
          headerName: "Preferred URL",
          description: 'Shows the URL that ranks for the selected keyword.',
          minWidth: 320,
          flex: 1,
          disableClickEventBubbling: true,
          headerAlign: "center",
          align: "center",
          renderCell: (cardData) => {
            console.log('cardData?.row?.preferred_url', cardData?.row?.preferred_url);
            let firstEightLetters = cardData?.row?.preferred_url;
            let baseUrl = firstEightLetters.split("/").slice(0, 3).join("/") + "/";
            let remaining = firstEightLetters.split("/").slice(3).join("/");
            return (
              <>
                <Tooltip title={cardData.row.preferred_url}>
                  <div className="preferred_url_external02">
                    <a target="_blank" href={cardData?.row?.preferred_url} style={{ display: 'flex', flexDirection: 'column' }}>
                      <span className="spanlink" style={{ alignItems: 'center' }}>
                        <LinkIcon /> {baseUrl}
                      </span>
                      <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                    </a>
                  </div>
                </Tooltip>
              </>
            )
          }
        },

      ];
      setColumns(firArray)
      if (datavalue.data) {
        var testValue = datavalue.data.keyword_settings;

        var fourArray = [{
          field: "edit",
          headerName: "Edit",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          align: "center",
          sortable: false,
          disableClickEventBubbling: true,
          renderCell: (cardData) => {
            return (
              <Tooltip title={'Click here to edit the keyword'}>
                <a className="EditBrandedTermClass" href="javascript:void(0)" data-id={cardData.row.id}>
                  <button className="buttonView edit_icon keyword-edit-icon" onClick={EditBrandedTerm}>

                    <EditIcon className="edit-icon-svg" />
                  </button>
                </a>
              </Tooltip>
            );
          },
        },
        {
          field: "delete",
          headerName: "Delete",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          align: "center",
          disableClickEventBubbling: true,
          sortable: false,
          renderCell: (cardData) => {
            return (
              <Tooltip title={'Click here to delete the keyword'}>
                <a className="DeleteBrandedtermClass" href="javascript:void(0)" >
                  <button className="buttonView trash_icon keyword-delete-icon"
                    onClick={() => handleDeleteClick(cardData.row.id)}


                    id={cardData.row.id}>

                    <DeleteIcon className="delete-icon-svg" />
                  </button>
                </a>
              </Tooltip>
            );
          },
        }]
        var c = firArray.concat(fourArray)
        setColumns(c)

      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const [campaigndata, setcampaigndata] = useState([]);
  const [campaignlist, setCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [prevSelectedCampaign, setPrevSelectedCampaign] = useState(null);


  const GetCampaignData = async () => {
    setcampaigndata([])

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/campaign_table/?user_domain_id=${esodata.domaindata.value.header_selected}`,

        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (response?.data) {
        var Sections = [];
        response.data.forEach((element) => {
          if (props.campTabSelection && props.campTabSelection === element.campaign_id) {
            setSelectedCampaign({
              label: element.campaign_name,
              value: element.campaign_id,
            });
            setPrevSelectedCampaign({
              label: element.campaign_name,
              value: element.campaign_id,
            });
          }
          Sections.push({
            label: element.campaign_name,
            value: element.campaign_id,
          });
        });
        setcampaigndata(Sections);
        console.log("data", Sections);
      }
    } catch (err) {
      console.log(err)
    }
  }


  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);
    const selectedCamp = selectedCampaign ? selectedCampaign?.value : props.campTabSelection && !isCampaignCleared ? props.campTabSelection : '';
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/v2/keyword_table/?user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${selectedCamp}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });


      if (datavalue?.data?.result) {
        if (datavalue?.data?.result) {
          const newData = datavalue?.data?.result.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          SetAutoheightval(false)
          setCardData(newData);
        }
      }
      else {
        SetAutoheightval(true)
        setCardData([]);
      }

      if (datavalue?.data) {
        setCampaignCount(datavalue?.data?.campaign_count || 0);
        setTotalKeywordCount(datavalue?.data?.total_keyword_count || 0);
        setBarChartData(datavalue?.data?.bar_chart_data || []);
      }

    } catch (err) {
      console.log(err)
    }

    props.setSubmitKeyword(false);
    setSubmitKeyword(false);
    setLoading(false);
    setTableLoading(false);

  };


  const EditBrandedTerm = (e) => {
    const Id = e.target.closest(".EditBrandedTermClass").getAttribute("data-id");
    setSelectedKeyword(Id);
    setKeywordEditPopup(true);
  }

  const DeleteBrandedterm = async (deleteid) => {
    setIsOpen(false);
    const Id = deleteid
    try {

      await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/keyword_delete/?user_domain_id=${esodata.domaindata.value.header_selected}&keyword_id=${Id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
        return false;
      });
      setSubmitKeyword(true);

    } catch (err) {
      console.log(err)
    }

  }

  function openModal() {
    setmodalIsFilter(true);
  }

  function closeModal() {
    setSelectedCampaign(prevSelectedCampaign);
    setmodalIsFilter(false);
  }

  const resetCampaignFilter = () => {
    setSelectedCampaign(null);
  }

  const keywordaddpopupCloseOk = () => {
    setkeyWordAddPopup(false);
    setSubmitKeyword(true);
  }

  useEffect(() => {
    GetDefaultSettings();
    callUserdataApi();
    GetCampaignData();
  }, [])

  useEffect(() => {
    if (props.CallPreferredList === true || props.submitKeyword == true || submitKeyword) {

      callUserdataApi()
    }

  }, [props.CallPreferredList, submitKeyword, props.submitKeyword])

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDownlodingCSV = () => {
    const selectedCamp = selectedCampaign ? selectedCampaign?.value : props.campTabSelection && !isCampaignCleared ? props.campTabSelection : '';
    props.csvdown(selectedCamp);
  }

  const handleDownlodingPDF = () => {
    const selectedCamp = selectedCampaign ? selectedCampaign?.value : props.campTabSelection && !isCampaignCleared ? props.campTabSelection : '';
    props.pdfdown(selectedCamp);
  }
  const handleModelPopUp = () => {
    openModal();

  }

  const submitCampaign = () => {
    // if (!selectedCampaign) {
    //   setCampError('This field is required.');
    // } else {
    // }
    setPrevSelectedCampaign(selectedCampaign);
    setCampError('');
    callUserdataApi();
    setmodalIsFilter(false);
  }

  const cardDatas = [
    {
      value: campaignCount || 0,
      title: "Total Campaign",
      iconSrc: GainedKeywordssvg,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: totalKeywordCount || 0,
      title: "Total Keyword",
      iconSrc: WarningCount,
      iconColor: 2,
      bgColor: 2,
    }

  ];

  const handleOnChange = (e) => {
    if (!e) {
      setIsCampaignCleared(true);
    } else {
      setIsCampaignCleared(false);
    }
    setSelectedCampaign(e);
  };


  return (
    <div>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box >
          <Grid container spacing={2} className="dashboard-box-card">
            <Grid container spacing={3} xs={12} sm={12} md={12} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={6} key={item.id}>
                  <Commoncard
                    item={item}
                    nonclikable={true}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} md={12}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Keywords by Campaign</Typography>
              <Chart
                type="bar"
                height={240}
                series={[{
                  name: "Count",
                  data: (barChartData || []).map(i => i?.keyword_count || 0)
                }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '45%',
                      borderRadius: 4,
                      distributed: true, // 👈 IMPORTANT
                      dataLabels: { position: 'top' }
                    }
                  },
                  colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                  dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: { fontSize: '12px' }
                  },
                  xaxis: {
                    categories: (barChartData || []).map(i => i?.campaign_name.length > 20 ? i?.campaign_name.slice(0, 25) + "..." || "" : i?.campaign_name || ""),
                    position: 'bottom',
                    labels: {
                      offsetX: 50,
                      style: { fontSize: '11px' }
                    }
                  },
                  yaxis: {
                    title: { text: 'Count' },
                    labels: { formatter: (val) => Math.floor(val) }
                  },
                  noData: { text: "No Metric Data Available" }
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "30px", marginBottom: "20px" }} >
        <Box style={{ background: "#fff", padding: "0px 20px 0px 20px" }} className="grid_table_shodow">
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 200]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                  DownloadShowFile={true}
                  handleDownlodingPDF={handleDownlodingPDF}
                  handleDownlodingCSV={handleDownlodingCSV}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "5px", marginBottom: "5px" }} >
        <Box style={{ padding: "0px 20px 0px 20px" }} >
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={6}>
              <div><p style={{ color: "#000" }}>All Rights Reserved Copyright © 2026 | <span style={{ color: "#ff601f" }}> Elite site Optimizer</span></p></div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{ display: "flex", gap: "30px", justifyContent: "end" }}>
                <p>
                  {/* <span
                          style={{ color: "#818181", cursor: "pointer" }}
                          onClick={handleToggle}
                        >
                          FAQ's
                        </span> */}
                </p></div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      {/* <DatagridComp
        columns={columns}
        rows={rows}
        autoheightval={autoheightval}
        datagridval={2}
        customFilter={false}
        columnFreezeWidth={[0, 200]}
        tableLoading={tableLoading}
      /> */}

      <Dialog
        open={modalIsFilter}
        onClose={closeModal}
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">Campaign</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="cnt_hdr_blw_wrap row">
              <div>
                <label>Selected Campaign</label>
                <Select
                  value={selectedCampaign}
                  options={campaigndata}
                  placeholder="Select Campaign..."
                  isClearable
                  onChange={handleOnChange}
                  styles={customDropdownStyles()}
                  menuPortalTarget={document.body}
                />
                {/* <div className="error-value">{campError}</div> */}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={submitCampaign}
          >
            Submit
          </button>

          <button onClick={closeModal}>Close</button>
          <button onClick={resetCampaignFilter}>Reset</button>
        </DialogActions>
      </Dialog>



      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">

              Are you sure you want to delete this Keyword Name?

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={handleConfirmDelete} style={{ cursor: 'pointer' }} >
            OK
          </button>
          <button style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
        </DialogActions>
      </Dialog>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <Dialog
        open={keywordeditpopup}
        onClose={() => setKeywordEditPopup(false)}
        PaperProps={{
          className: 'keyword-dialog',
        }}
      >
        <DialogTitle className="keyword-dialog-header">{"Edit Keywords"}</DialogTitle>
        <DialogContent className="update-user-dialog">
          <KeywordEditForm
            setKeywordEditPopup={setKeywordEditPopup}
            selectedKeyword={selectedKeyword}
            setSubmitKeyword={setSubmitKeyword}
            setsuccespopup={setsuccespopup}
            setkeyWordAddPopup={setkeyWordAddPopup}
          />
        </DialogContent>
      </Dialog>
      <CommonErrorAlert
        data={{
          apiopen: keywordaddpopup,
          apiErrorMsg: succespopup,
          isIconStyled: false
        }}
        closeAlert={keywordaddpopupCloseOk} />

    </div>)

}
export default PreferredList